import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import { createTheme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import Skeleton from '@mui/material/Skeleton';

import colors from '../../constants/colors';

import './SwitchCustom.css';

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          borderColor: '#D5D5D5',
        },
        '&:hover $notchedOutline': {
          borderColor: '#D5D5D5',
        },
        '&$focused $notchedOutline': {
          borderColor: '#D5D5D5',
        },
      },
    },
  },
});

const SwitchCustom = ({ 
  options, handleSwitch, switchStatus, disabledStatus, isDualOption, switchValue, loading, validateCheckedStatus
}) => {
  const [labelOptions] = useState(options);
  const [isDisabled, setIsDisabled] = useState(disabledStatus);

  useEffect(() => {
    setIsDisabled(disabledStatus);
  }, [disabledStatus]);

  const OrangeSwitch = withStyles({
    switchBase: {
      '&$checked': {
        color: theme.palette.common.white,
      },
      '&$checked + $track': {
        opacity: 1,
        backgroundColor: isDualOption ? colors.blue : colors.success,
        borderColor: isDualOption ? colors.blue : colors.success,
      },
    },
    checked: {},
    track: {
      opacity: 1,
      backgroundColor: isDualOption ? colors.blue : colors.grey,
    },
    input: {
      left: '0'
    }
  })(Switch);

  const modifySwitchStatus = () => {
    setIsDisabled(!isDisabled);
  }

  const handleChecked = (event, status) => {
    if (validateCheckedStatus) {
      handleSwitch(status, event.target.value, modifySwitchStatus);
    }
    else {
      handleSwitch(status, event.target.value);
    }
  }

  if (loading) return (
    <Skeleton width={30} height={30} variant='circle' />
  )

  return (
    <>
      <Grid component='label' container alignItems='center'>
        {labelOptions && labelOptions.leftTitle && 
          (<Grid className='switch__wrapper__title' item>{labelOptions.leftTitle}</Grid>)
        }
        <Grid item>
          <OrangeSwitch
            value={switchValue}
            checked={switchStatus}
            onChange={handleChecked}
            inputProps={{ 'aria-label': 'primary checkbox' }}
            disabled={isDisabled}
          />
        </Grid>
        {labelOptions && labelOptions.rightTitle && 
          (<Grid className='switch__wrapper__title' item>{labelOptions.rightTitle}</Grid>)
        }
      </Grid>
    </>
  );
};

SwitchCustom.propTypes = {
  switchValue: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.object,
  handleSwitch: PropTypes.func.isRequired,
  switchStatus: PropTypes.bool,
  disabledStatus: PropTypes.bool,
  isDualOption: PropTypes.bool,
  loading: PropTypes.bool,
  validateCheckedStatus: PropTypes.bool
};

SwitchCustom.defaultProps = {
  switchValue: '',
  options: null,
  switchStatus: false,
  disabledStatus: false,
  isDualOption: false,
  loading: false,
  validateCheckedStatus: false
};

export default SwitchCustom;
